import { lazy } from 'react';

const MediaPreviewConfig = {
  settings: {
    layout: {
      style: 'layout1',
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        mode: 'fullwidth',
      },
    },
  },
  routes: [
    {
      path: '/media-preview',
      component: lazy(() => import('./index.js')),
    },
  ],
};

export default MediaPreviewConfig;
